module.exports = __webpack_public_path__ + "img/logo.ab1a83bf.png";